import { render } from "./CardShopping.vue?vue&type=template&id=6854cae0&scoped=true"
import script from "./CardShopping.vue?vue&type=script&lang=js"
export * from "./CardShopping.vue?vue&type=script&lang=js"

import "./CardShopping.vue?vue&type=style&index=0&id=6854cae0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6854cae0"

export default script